<template>
  <div>
    <el-dialog :title="changePlanData.title" center :visible.sync="changePlanData.show" width="400px">
      <div v-if="changePlanData.rowData.planName != '--'" style="margin-bottom: 30px;">当前代理方案：{{changePlanData.rowData.planName}} ({{changePlanData.rowData.AgentUseId}})</div>
      <el-form inline :model="editForm">
        <el-form-item label="变更方案名称" >
          <el-select @change="changePlan" v-model="editForm.AgentUseId" placeholder="变更方案名称" clearable>
            <el-option v-for="(item, index) in changePlanData.list" :key="index" :label="`${item.Name}(${item.Id})`"
              :value="item.Id"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData">{{$t('Confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    changePlanData: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      editForm:{
        AgentUseId: "",
      },
      planId:""
    };
  },
  methods: {
    changePlan(val){
      this.planId = val
    },
    submitData() { 
      if(this.planId == this.changePlanData.rowData.AgentUseId) return this.$message.warning('变更方案不能与当前方案相同')
      this.changePlanData.rowData.AgentUseId = this.editForm.AgentUseId
      this.$emit('confirmChangePlanData', this.changePlanData.rowData)
    },
  },
};
</script>

<style  scoped>
.a {
  text-align: center;
}
</style>